import { createFileRoute } from '@tanstack/react-router';

import { AgentsSkillsPage } from '@/features/workspace-files';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/files/agents-skills',
)({
  component: AgentsSkillsPage,
});
